/**
 * The slot registrations of `web/bootstrap` (CS r5b deliverable 165): the sidebar's "Bootstrap
 * past sessions" link (`shell.workspace.bootstrap`) and the Settings section
 * (`settings.sections.bootstrap`). Both render nothing with `flag:sessions` off.
 * `apps/web/src/editor-services/slots.ts` collects them as `SLOT_MODULES['web/bootstrap']`.
 */
import type { SlotRegistration, WorkPackageId } from '@codex/contracts';
import { SettingsBootstrapSection, SidebarBootstrapEntry } from './entry.js';

export const owner: WorkPackageId = '2.J';

export const slotRegistrations: readonly SlotRegistration[] = [
  { slot: 'shell.workspace', order: 20, owner: '2.J', component: SidebarBootstrapEntry },
  { slot: 'settings.sections', order: 20, owner: '2.J', component: SettingsBootstrapSection },
];
